import { loadScript } from "@paypal/paypal-js";
import { MessageTooltipAttribute, MessageTooltipScope } from "./qp-message-tooltip.interface";
import tpl from "./qp-message-tooltip.template.html";
import is, { isUndefined } from "@core/comparators/is";

export function QpMessageTooltip($translate: angular.translate.ITranslateService): ng.IDirective {
    return {
        restrict: 'EA',
        template: tpl,
        scope: {
            qpMsgTipTitle: '@',
            qpMsgTipPlacement: '@',
            qpMsgTipTrigger: '@',
            qpMsgTipCode: '@',
            qpMsgTipDsc: '@',
            qpMsgUrl: '@',

        },
        link: (
            scope: MessageTooltipScope,
            elements: JQLite,
            attrs: MessageTooltipAttribute,
            ctrl?: angular.IController,
            transcludeFn?: angular.ITranscludeFunction
        ) => {
            scope.qpMsgTipTitle = is.emptyString(attrs.qpMsgTipTitle) || is.nullOrUndefined(attrs.qpMsgTipTitle) ? undefined : attrs.qpMsgTipTitle;
            scope.qpMsgTipPlacement = is.emptyString(attrs.qpMsgTipPlacement) || is.nullOrUndefined(attrs.qpMsgTipPlacement) ? "bottom" : attrs.qpMsgTipPlacement;
            scope.qpMsgTipTrigger = is.emptyString(attrs.qpMsgTipTrigger) || is.nullOrUndefined(attrs.qpMsgTipTrigger) ? "mouseenter" : attrs.qpMsgTipTrigger;
            scope.qpMsgTipCode = is.emptyString(attrs.qpMsgTipCode) || is.nullOrUndefined(attrs.qpMsgTipCode) ? undefined : attrs.qpMsgTipCode;
            scope.qpMsgTipDsc = is.emptyString(attrs.qpMsgTipDsc) || is.nullOrUndefined(attrs.qpMsgTipDsc) ? undefined : attrs.qpMsgTipDsc;
            scope.qpMsgUrl = is.emptyString(attrs.qpMsgUrl) || is.nullOrUndefined(attrs.qpMsgUrl) ? '' : attrs.qpMsgUrl;
            if (attrs.qpMsgTipCode != null || attrs.qpMsgTipCode != undefined ||
                attrs.qpMsgTipDsc != null || attrs.qpMsgTipDsc != undefined
            ) {
                scope.qpMsgTipTrigger = "outsideClick";
            }
            scope.isCollapsed = true;
            if ((scope.qpMsgTipCode != undefined || scope.qpMsgTipDsc != undefined) && scope.qpMsgUrl == '') {
                scope.templateType = "ToolTipMore";
            } else if (scope.qpMsgTipCode == undefined && scope.qpMsgTipDsc == undefined && scope.qpMsgUrl == '') {
                scope.templateType = "ToolTip";
            } else if (scope.qpMsgUrl != '') {
                scope.templateType = "QpMsgTipPlacement";
            }
        }
    }
};


//-----------------------------------------------------
// SECTION - 2. 指令注入
//-----------------------------------------------------
QpMessageTooltip.$inject = ['$translate'];